import { ArrayTableSectionSchema } from 'features/libra/sections/arrayTableSection/arrayTableSectionTypes'
import { ComputedSectionSchema } from 'features/libra/sections/computedSection/computedSectionTypes'
import { FlowchartSectionSchema } from 'features/libra/sections/flowchartSection/flowchartTypes'
import { FormSectionSchema } from 'features/libra/sections/formSection/formSectionTypes'
import { z } from 'zod'

export enum SectionType {
  FORM = 'form',
  FLOWCHART = 'flowchart',
  COMPUTED = 'computed',
  ARRAY_TABLE = 'array_table',
}

export const SectionSchema = z.union([
  FlowchartSectionSchema,
  FormSectionSchema,
  ComputedSectionSchema,
  ArrayTableSectionSchema,
])

export type FormSection = z.infer<typeof FormSectionSchema>
export type FlowchartSection = z.infer<typeof FlowchartSectionSchema>
export type ComputedSection = z.infer<typeof ComputedSectionSchema>
export type ArrayTableSection = z.infer<typeof ArrayTableSectionSchema>
export type Section =
  | FormSection
  | FlowchartSection
  | ComputedSection
  | ArrayTableSection
